<div>
    <app-header [title]="headerTitle" [back]="true"></app-header>

    <ui-banner
        *ngIf="editMode && appSteps.isCurrentStep(questionsStep)"
        variant="warning"
        class="margin-bottom-2"
        [closable]="false"
    >
        <p>{{ 'applicant-tracker.messages.interview.anyEditsMadeToQuestionsWillOnlyApply' | translate }}</p>
    </ui-banner>

    <app-steps
        #appSteps
        action="click"
        [options]="{ allowCompletionIfFormIsInvalid: true }"
        [steps]="[detailsStep, questionsStep]"
        (onPrimary)="onSave()"
    >
        <app-step #detailsStep [stepForm]="details" [embeddedCard]="false" step="applicant-tracker.details">
            <div class="app-grid">
                <div class="columns-5">
                    <app-job-posting-interview-store-details
                        #details
                        [interview]="interview"
                    ></app-job-posting-interview-store-details>
                </div>
                <div class="columns-7">
                    <ui-card variant="dark" class="interview-card">
                        <app-segment-header
                            class="margin-bottom-1"
                            title="applicant-tracker.preview"
                        ></app-segment-header>
                        <app-job-posting-interview-questions-preview
                            [interviewQuestions]="interview.interviewQuestions"
                        ></app-job-posting-interview-questions-preview>
                    </ui-card>
                </div>
            </div>
        </app-step>

        <app-step #questionsStep [stepForm]="questions" [embeddedCard]="false" step="applicant-tracker.questions">
            <app-applicant-interview-question-dialog
                #questions
                [openDialog]="openQuestionDialog"
                (closeApplicantInterviewQuestionDialog)="closeApplicantInterviewQuestionDialog()"
                (addApplicantInterviewQuestion)="addApplicantInterviewQuestion($event)"
            ></app-applicant-interview-question-dialog>

            <div class="app-grid">
                <div class="columns-5">
                    <ui-card class="interview-card">
                        <app-segment-header with title="applicant-tracker.questions" />
                        <div class="margin-top-1 margin-bottom-1">
                            {{ 'applicant-tracker.messages.interview.addAQuestionForInterviewersToAsk' | translate }}
                        </div>
                        <hr />
                        <app-job-posting-interview-questions-card
                            [interviewQuestions]="interview.interviewQuestions"
                            (onInterviewQuestionsChanged)="handleInterviewQuestionsChanged($event)"
                        ></app-job-posting-interview-questions-card>
                        <ui-button (click)="openAddQuestionDialog()" type="link"
                            >{{ 'applicant-tracker.addAQuestion' | translate }}
                        </ui-button>
                    </ui-card>
                </div>
                <div class="columns-7">
                    <ui-card variant="dark" class="interview-card">
                        <app-segment-header class="margin-bottom-1" title="applicant-tracker.preview" />
                        <app-job-posting-interview-questions-preview
                            [interviewQuestions]="interview.interviewQuestions"
                        ></app-job-posting-interview-questions-preview>
                    </ui-card>
                </div>
            </div>
        </app-step>
    </app-steps>
</div>
